import React, { createContext, ReactNode, useCallback, useMemo, useState } from 'react';

interface PrintChartProviderProps {
  children: ReactNode;
}

interface PrintChartContextValue {
  isPrintReport: boolean;
  pendingCharts: number;
  registerChart: (id: string) => void;
  markChartReady: (id: string) => void;
}

const noop = () => {};

export const PrintChartContext = createContext<PrintChartContextValue>({
  isPrintReport: false,
  pendingCharts: 0,
  registerChart: noop,
  markChartReady: noop
});

export const PrintChartProvider = ({ children }: PrintChartProviderProps) => {
  const [pendingChartIds, setPendingChartIds] = useState<Set<string>>(new Set());

  const registerChart = useCallback((id: string) => {
    setPendingChartIds((current) => {
      const next = new Set(current);
      next.add(id);
      return next;
    });
  }, []);

  const markChartReady = useCallback((id: string) => {
    setPendingChartIds((current) => {
      const next = new Set(current);
      next.delete(id);
      return next;
    });
  }, []);

  const value = useMemo(
    () => ({
      isPrintReport: true,
      pendingCharts: pendingChartIds.size,
      registerChart,
      markChartReady
    }),
    [markChartReady, pendingChartIds.size, registerChart]
  );

  return <PrintChartContext.Provider value={value}>{children}</PrintChartContext.Provider>;
};
